"use client";

import { useComparisonStoreData } from "@/providers/global";
import { trackEvent } from "@/utils/analytics/track-event";
import { ChevronUp } from "lucide-react";
import { usePathname } from "next/navigation";
import { useCallback } from "react";

export function MobileComparisonBadge() {
	const comparisonTray = useComparisonStoreData(state => state.comparisonTray);
	const isComparisonMinimized = useComparisonStoreData(state => state.isComparisonMinimized);
	const setIsComparisonMinimized = useComparisonStoreData(state => state.setIsComparisonMinimized);
	const pathname = usePathname();

	const handleClick = useCallback(() => {
		setIsComparisonMinimized(false);

		trackEvent({
			google: {
				event: "expand_comparison_from_badge",
				options: {
					property_count: comparisonTray?.length || 0,
				},
			},
		});
	}, [setIsComparisonMinimized, comparisonTray]);

	// Hide the badge if we're on the compare page
	if (pathname === "/compare") return null;

	// Only show if minimized and has properties
	if (!isComparisonMinimized || !comparisonTray || comparisonTray.length === 0) return null;

	return (
		<div className="fixed z-50 right-0 top-1/2 -translate-y-1/2">
			<button
				onClick={handleClick}
				className="bg-primary text-white shadow-lg hover:shadow-xl transition-all duration-300 group
					flex flex-col items-center gap-2 py-3 px-2 rounded-l-md
					select-none cursor-pointer"
				aria-label="Expand comparison"
			>
				<ChevronUp className="w-3 h-3 -rotate-90 group-hover:translate-x-[-2px] transition-transform" />
				<div className="flex flex-col items-center gap-2">
					<div className="relative">
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
							/>
						</svg>
						<span className="absolute -top-1 -right-1 bg-white text-primary text-[9px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center border border-primary">
							{comparisonTray.length}
						</span>
					</div>
					<div className="flex flex-col items-center [writing-mode:vertical-rl]">
						<span className="font-semibold text-[10px] whitespace-nowrap">Compare</span>
					</div>
				</div>
			</button>
		</div>
	);
}
